// MF v2 requires the entrypoint to be an async import so the shared
// scope resolves before any federated module is touched.
import("./bootstrap");
export {};
